import { Directive, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS } from '@angular/forms';
import { InputSelectionTableItem } from '../../../models/data-structures/input-selection-table-item.model';

@Directive({
  selector: '[appSensitivityTableItemValidator][ngModel]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: SensitivityTableItemValidatorDirective,
    multi: true
  }]
})
export class SensitivityTableItemValidatorDirective {
  @Input() sensTableItem?: InputSelectionTableItem;

  validate(control: UntypedFormControl) {
    let isValid = true;
    if (this.sensTableItem) {
      if (control.errors) {
        return {invalid: true};
      }
      if (this.sensTableItem.minErrorHints && this.sensTableItem.minErrorHints.length > 0) {
        isValid = false;
      }
      if (this.sensTableItem.maxErrorHints && this.sensTableItem.maxErrorHints.length > 0) {
        isValid = false;
      }
      return isValid ? null : {invalid: !isValid};
    }
  }
}
